"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectString = exports.MultiSelect = void 0;
const mobx_1 = require("mobx");
const light_1 = require("@zajno/common/lazy/light");
const math_1 = require("@zajno/common/math");
const FlagModel_1 = require("./FlagModel");
const Validatable_1 = require("./Validatable");
const wrappers_1 = require("@zajno/common/models/wrappers");
class MultiSelect extends Validatable_1.ValidatableModel {
    constructor(_items, _accessor, ...selected) {
        super();
        this._items = _items;
        this._accessor = _accessor;
        this._indexes = new Set();
        this.opened = new FlagModel_1.FlagModel();
        this._initial = null;
        this._flags = (0, light_1.createLazy)(() => this.createFlags());
        this._indexesLocked = false;
        this.setItemSelected = (item, selected) => {
            const i = this.items.indexOf(item);
            if (i >= 0) {
                this.setIndexSelected(i, selected);
            }
        };
        this.selectItem = (item) => this.setItemSelected(item, true);
        this.deSelectItem = (item) => this.setItemSelected(item, false);
        this.selectItems = (items) => {
            items.forEach(this.selectItem);
        };
        this.setValueSelected = (value, selected) => {
            const i = this.values.indexOf(value);
            if (i >= 0) {
                this.setIndexSelected(i, selected);
            }
        };
        this.selectValue = (value) => this.setValueSelected(value, true);
        this.deSelectValue = (value) => this.setValueSelected(value, false);
        this.selectValues = (values) => {
            values.forEach(this.selectValue);
        };
        this.setIndexSelected = (index, selected) => {
            if (this._indexesLocked) {
                return;
            }
            if (selected) {
                this._indexes.add(index);
            }
            else {
                this._indexes.delete(index);
            }
            if (this._validateOnChange) {
                this.validate();
            }
            if (!this._flags.hasValue) {
                return;
            }
            try {
                this._indexesLocked = true;
                this._flags.value[index].value = selected;
            }
            finally {
                this._indexesLocked = false;
            }
        };
        this.selectIndex = (index) => this.setIndexSelected(index, true);
        this.deSelectIndex = (index) => this.setIndexSelected(index, false);
        this.reset = () => {
            super.reset();
            this.setInitialIndexes();
        };
        this._initial = selected;
        this.setInitialIndexes();
        (0, mobx_1.makeObservable)(this, {
            '_indexes': mobx_1.observable,
            selectedIndexes: mobx_1.computed,
            values: mobx_1.computed,
            selectedItems: mobx_1.computed,
            selectedValues: mobx_1.computed,
            isDefault: mobx_1.computed,
            selectItems: mobx_1.action,
            selectValues: mobx_1.action,
            setIndexSelected: mobx_1.action,
        });
    }
    get selectedIndexes() { return Array.from(this._indexes); }
    get items() { return this._items; }
    get flags() { return this._flags.value; }
    get values() {
        return this._items.map(i => this._accessor(i));
    }
    get selectedItems() {
        return this.selectedIndexes.map(i => this._items[i]);
    }
    get selectedValues() {
        const values = this.values;
        return this.selectedIndexes.map(i => values[i]);
    }
    get value() { return this.selectedValues; }
    set value(v) { this.selectValues(v); }
    isIndexSelected(index) { return this._indexes.has(index); }
    isValueSelected(value) { return this.selectedValues.includes(value); }
    get count() { return this._items.length; }
    get selectedCount() { return this._indexes.size; }
    get isEmpty() { return this.selectedCount === 0; }
    get isDefault() { var _a; return ((_a = (0, math_1.arraysCompareDistinct)(this.selectedIndexes, this._initial)) === null || _a === void 0 ? void 0 : _a.diff) === 0; }
    get valueToValidate() { return this.selectedItems; }
    setInitialIndexes() {
        this._indexes.clear();
        this._initial.forEach(i => this._indexes.add(i));
        if (this._flags.hasValue) {
            this._flags.value.forEach((flag, index) => flag.value = this._indexes.has(index));
        }
    }
    createFlags() {
        const flags = this._items
            .map((item, index) => {
            const flag = (0, wrappers_1.withLabel)(new FlagModel_1.FlagModel(this._indexes.has(index)), () => this._accessor(item));
            (0, mobx_1.reaction)(() => flag.value, isSelected => {
                this.setIndexSelected(index, isSelected);
            });
            return flag;
        });
        return flags;
    }
}
exports.MultiSelect = MultiSelect;
class MultiSelectString extends MultiSelect {
    constructor(items, ...selected) {
        super(items, v => v, ...selected);
    }
}
exports.MultiSelectString = MultiSelectString;
//# sourceMappingURL=MultiSelectModel.js.map